/**
 * Created by Tomasz Gabrysiak @ Infermedica on 14/02/2017.
 */

function htmlEscape (str) {
  return str.replace(/&/g, '&amp;')
    .replace(/>/g, '&gt;')
    .replace(/</g, '&lt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/`/g, '&#96;');
}
export default function html (literalSections, ...substs) {
  let raw = literalSections.raw;
  let result = '';
  substs.forEach((subst, i) => {
    let lit = raw[i];

    if (Array.isArray(subst)) {
      subst = subst.join('');
    }

    if (lit.endsWith('$')) {
      subst = htmlEscape(subst);
      lit = lit.slice(0, -1);
    }

    result += lit;
    result += subst;
  });
  result += raw[raw.length - 1];
  return result;
}



// WEBPACK FOOTER //
// ./src/templates/helpers.js